var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowleft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3014 2.1562L3.87135 6.7008C3.79355 6.78063 3.75 6.88769 3.75 6.99916C3.75 7.11063 3.79355 7.21769 3.87135 7.29751L8.3014 11.8438C8.33764 11.8811 8.38098 11.9106 8.42884 11.9308C8.47671 11.951 8.52814 11.9615 8.58009 11.9615C8.63205 11.9615 8.68348 11.951 8.73134 11.9308C8.77921 11.9106 8.82254 11.8811 8.85879 11.8438C8.93335 11.7675 8.9751 11.665 8.9751 11.5583C8.9751 11.4516 8.93335 11.3491 8.85879 11.2728L4.6929 6.99916L8.85879 2.72641C8.9331 2.65011 8.97468 2.54781 8.97468 2.44131C8.97468 2.3348 8.9331 2.2325 8.85879 2.1562C8.82254 2.11897 8.77921 2.08939 8.73134 2.06918C8.68348 2.04898 8.63205 2.03857 8.58009 2.03857C8.52814 2.03857 8.47671 2.04898 8.42884 2.06918C8.38098 2.08939 8.33764 2.11897 8.3014 2.1562Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/arrowleft.ae4adaa7cd75fc98fe81b479c8c89417.svg";
export { ForwardRef as ReactComponent };